/**
 * Column math for the recipe browser grids ("Suggestions de recettes").
 *
 * Pure and dependency-free so the "does a row actually fit?" invariant can be
 * unit-tested — it is the thing that broke when the grid was sized off the
 * window width instead of the content column.
 */

/** Below this a card's image and two-line title stop reading well. */
export const CARD_MIN_WIDTH = 180;
/** Cards get comically wide past this on an ultra-wide monitor. */
export const CARD_MAX_COLUMNS = 5;
export const CARD_GAP = 12;
/** Per side. Must match `styles.searchList.paddingHorizontal` in recipes.tsx. */
export const LIST_HORIZONTAL_PADDING = 18;

export interface RecipeGridLayout {
  numColumns: number;
  cardWidth: number;
}

/**
 * @param contentWidth width of the column the grid lives in — NOT the window
 *        width on desktop web, where the sidebar sits outside it.
 */
export function computeRecipeGridLayout(contentWidth: number): RecipeGridLayout {
  const availableWidth = contentWidth - LIST_HORIZONTAL_PADDING * 2;
  const numColumns = Math.min(
    CARD_MAX_COLUMNS,
    Math.max(2, Math.floor((availableWidth + CARD_GAP) / (CARD_MIN_WIDTH + CARD_GAP)))
  );
  const cardWidth = (availableWidth - CARD_GAP * (numColumns - 1)) / numColumns;
  return { numColumns, cardWidth };
}
